import React, { useEffect, useState } from "react";
import { getProductImages, streamProductImage } from "../lib/upcImageData";
import eventEmitter from "../../../../shared/events";
import { EVENT_VIEW_UPC_IMAGE } from "../lib/constants";

const ProductImage = (props) => {
    const [image, setImage] = useState("");
    useEffect(() => {
        // TODO: does this have to be an image stream anymore?
        streamProductImage(props.shipmentKey, props.productKey, props.number).then((img) => {
            setImage(img);
        });
    }, []);

    const onPhotoClick = (e) => {
        e.stopPropagation();
        const resourceDetail = {
            img: e.target.src,
        };
        eventEmitter.emit(EVENT_VIEW_UPC_IMAGE, resourceDetail);
    };

    return <img alt={`Product ${props.number}`} src={image} onClick={onPhotoClick} />;
};

export const ProductImageList = ({ shipmentKey, product }) => {
    const [images, setImages] = useState([]);
    const productKey = product.key;
    let mounted = true;

    useEffect(() => {
        loadProductImages(productKey).then((response) => {
            if (mounted) {
                setImages(response);
            }
        });

        return () => {
            mounted = false;
        };
    }, []);

    const loadProductImages = async (id) => {
        const response = await getProductImages(shipmentKey, id);

        return response;
    };

    const thumbnails = images.map((img) => {
        return <ProductImage key={`${shipmentKey}_${productKey}_${img.number}`} shipmentKey={shipmentKey} productKey={productKey} number={img.number} />;
    });

    return <div className="image-thumbs">{thumbnails}</div>;
};
